<template>
    <div class="step8">
        <h1>Aanvraagformulier</h1>
        <h2>Bewijs</h2>

        <application-stepper current-step="8" :loading="!loaded">
            <h3>Bijlage</h3>
            <template v-if="!applicant.requireAnyDocument">
                <p>
                    geen extra bijlage benodigd.
                </p>
            </template>
            <v-form @submit.prevent="submit">
                <v-error-messages ref="errorMessages" :messages="this.errorMessages"></v-error-messages>
                <template v-if="applicant.requireEducationContract">
                    <h3>Onderwijsovereenkomst</h3>
                    <v-file-input-dropzone
                        class="my-2"
                        v-model="applicant.documents.EDUCATION_CONTRACT"
                        tooltip="Klik hier of sleep bestanden naar dit vlak"
                        label="Voeg bewijs toe: Onderwijsovereenkomst"
                        style="height: 200px"
                        @file-added="applicantDocumentEDUCATION_CONTRACTAdded"
                        @file-removed="applicantDocumentEDUCATION_CONTRACTRemove"
                        :error="hasErrors('EDUCATION_CONTRACT')" :error-messages="handleErrors('EDUCATION_CONTRACT')"
                    ></v-file-input-dropzone>
                </template>
                <template v-if="applicant.requireHealthInsurancePolicy">
                    <h3>Zorgpolis</h3>
                    <v-file-input-dropzone
                        class="my-2"
                        v-model="applicant.documents.HEALTH_INSURANCE_POLICY"
                        tooltip="Klik hier of sleep bestanden naar dit vlak"
                        label="Voeg bewijs toe: Zorgpolis"
                        style="height: 200px"
                        @file-added="applicantDocumentHEALTH_INSURANCE_POLICYAdded"
                        @file-removed="applicantDocumentHEALTH_INSURANCE_POLICYRemove"
                        :error="hasErrors('HEALTH_INSURANCE_POLICY')" :error-messages="handleErrors('HEALTH_INSURANCE_POLICY')"
                    ></v-file-input-dropzone>
                </template>
                <template v-if="applicant.requireMedicalConsent">
                    <h3>Medische toestemmingsverklaring</h3>
                    <v-file-input-dropzone
                        class="my-2"
                        v-model="applicant.documents.MEDICAL_CONSENT"
                        tooltip="Klik hier of sleep bestanden naar dit vlak"
                        label="Voeg bewijs toe: Medische toestemmingsverklaring."
                        style="height: 200px"
                        @file-added="applicantDocumentMEDICAL_CONSENTAdded"
                        @file-removed="applicantDocumentMEDICAL_CONSENTRemove"
                        :error="hasErrors('MEDICAL_CONSENT')" :error-messages="handleErrors('MEDICAL_CONSENT')"
                    ></v-file-input-dropzone>
                </template>
                <template v-if="applicant.requireQuotation">
                    <h3>Offerte</h3>
                    <v-file-input-dropzone
                        class="my-2"
                        v-model="applicant.documents.QUOTATION"
                        tooltip="Klik hier of sleep bestanden naar dit vlak"
                        label="Voeg bewijs toe: Offerte."
                        style="height: 200px"
                        @file-added="applicantDocumentQUOTATIONAdded"
                        @file-removed="applicantDocumentQUOTATIONRemove"
                        :error="hasErrors('QUOTATION')" :error-messages="handleErrors('QUOTATION')"
                    ></v-file-input-dropzone>
                </template>
                <template v-if="applicant.requireSocialSupportAct">
                    <h3>WMO beschikking</h3>
                    <v-file-input-dropzone
                        class="my-2"
                        v-model="applicant.documents.SOCIAL_SUPPORT_ACT"
                        tooltip="Klik hier of sleep bestanden naar dit vlak"
                        label="Voeg bewijs toe van WMO beschikking."
                        style="height: 200px"
                        @file-added="applicantDocumentSOCIAL_SUPPORT_ACTAdded"
                        @file-removed="applicantDocumentSOCIAL_SUPPORT_ACTRemove"
                        :error="hasErrors('SOCIAL_SUPPORT_ACT')" :error-messages="handleErrors('SOCIAL_SUPPORT_ACT')"
                    ></v-file-input-dropzone>
                </template>
                <template v-if="applicant.requireSpecialWelfare">
                    <h3>Bijzondere bijstand beschikking</h3>
                    <v-file-input-dropzone
                        class="my-2"
                        v-model="applicant.documents.SPECIAL_WELFARE_CONTACT"
                        tooltip="Klik hier of sleep bestanden naar dit vlak"
                        label="Voeg bewijs toe van het contact met de bijzondere bijstand."
                        style="height: 200px"
                        @file-added="applicantDocumentSPECIAL_WELFARE_CONTACTAdded"
                        @file-removed="applicantDocumentSPECIAL_WELFARE_CONTACTRemove"
                        :error="hasErrors('SPECIAL_WELFARE_CONTACT')" :error-messages="handleErrors('SPECIAL_WELFARE_CONTACT ')"
                    ></v-file-input-dropzone>
                </template>
                <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-btn @click="back" :loading="backBtnClicked" :disabled="submitting">Vorige</v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn color="primary" @click="submit" :loading="submitBtnClicked" :disabled="submitting"
                        >Volgende
                        </v-btn
                        >
                    </v-col>
                </v-row>
            </v-form>
        </application-stepper>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import ApplicationStepper from '../components/ApplicationStepper';
import VErrorMessages from '@/components/VErrorMessages';
import VFileInputDropzone from '@/components/VFileInputDropzone';
import BackendService from '../services/BackendService';
import Attachment from '../types/Attachment';

export default {
    name: 'step8-expense',
    components: {
        ApplicationStepper,
        VErrorMessages,
        VFileInputDropzone,
    },
    data: () => ({
        errorDetails: {},
        loaded: false,
        backBtnClicked: false,
        submitBtnClicked: false,
        submitting: false,

        errorMessages: [],
        applicant: {
            requireEducationContract: false,
            requireHealthInsurancePolicy: false,
            requireMedicalConsent: false,
            requireQuotation: false,
            requireSocialSupportAct: false,
            requireSpecialWelfare: false,
            requireAnyDocument: true,
            documents: {
                SPECIAL_WELFARE_CONTACT: [],
                SOCIAL_SUPPORT_ACT: [],
                MEDICAL_CONSENT: [],
                EDUCATION_CONTRACT: [],
                QUOTATION: [],
                HEALTH_INSURANCE_POLICY: [],
            }
        },
    }),
    computed: {
        ...mapGetters({vuex: 'step8'}),
    },
    created: function () {
        const that = this;

        this.step8Load().then(function () {
            that.applicant.requireEducationContract = that.vuex.applicant.requireEducationContract;
            that.applicant.requireHealthInsurancePolicy = that.vuex.applicant.requireHealthInsurancePolicy;
            that.applicant.requireMedicalConsent = that.vuex.applicant.requireMedicalConsent;
            that.applicant.requireQuotation = that.vuex.applicant.requireQuotation;
            that.applicant.requireSocialSupportAct = that.vuex.applicant.requireSocialSupportAct;
            that.applicant.requireSpecialWelfare = that.vuex.applicant.requireSpecialWelfare;
            that.applicant.requireAnyDocument = that.vuex.applicant.requireAnyDocument;
            that.applicant.documents.SPECIAL_WELFARE_CONTACT = that.vuex.applicant.documents.SPECIAL_WELFARE_CONTACT;
            that.applicant.documents.SOCIAL_SUPPORT_ACT = that.vuex.applicant.documents.SOCIAL_SUPPORT_ACT;
            that.applicant.documents.MEDICAL_CONSENT = that.vuex.applicant.documents.MEDICAL_CONSENT;
            that.applicant.documents.EDUCATION_CONTRACT = that.vuex.applicant.documents.EDUCATION_CONTRACT;
            that.applicant.documents.QUOTATION = that.vuex.applicant.documents.QUOTATION;
            that.applicant.documents.HEALTH_INSURANCE_POLICY = that.vuex.applicant.documents.HEALTH_INSURANCE_POLICY;

            that.loaded = true;
        });
    },
    methods: {
        ...mapActions(['step8Load', 'step8Submit']),
        attachmentRemoved(collection, attachment) {
            attachment.isInProgress = true;
            BackendService.attachmentRemove(attachment.id)
                .then(function () {
                    // reactively remove file from collection
                    collection.splice(collection.indexOf(attachment), 1);
                })
                .finally(function () {
                    attachment.isInProgress = false;
                });
        },
        hasErrors(name) {
            return '' !== this.handleErrors(name);
        },
        handleErrors(name) {
            if (this.errorDetails[name] !== undefined) {
                let error = '';
                Object.entries(this.errorDetails[name]).forEach(entry => {
                    const [errorType, value] = entry;
                    error += " " + value;
                });
                return error;
            }
            return '';
        },
        applicantAttachmentAdded(collection, type, file, errorKey) {
            const attachment = new Attachment();
            let dis = this;
            attachment.filename = file.name;
            attachment.isComplete = false;
            attachment.percentCompleted = 0;

            collection.push(attachment);

            BackendService.applicantAttachmentAdd(type, file, function (progressEvent) {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                attachment.percentCompleted = percentCompleted;
            }).then(function(response) {
                attachment.id = response.data.data.id;
                if(errorKey !== undefined){
                    dis.$delete(dis.errorDetails, errorKey)
                }
            }).catch(function (error) {
                collection.splice(collection.indexOf(attachment), 1);
                if(errorKey !== undefined) {
                    dis.errorDetails[errorKey] = {"fileupload": "Uploaden mislukt, mogelijk is het bestand te groot!"};
                }
            });
        },
        applicantDocumentSPECIAL_WELFARE_CONTACTRemove(attachment){
            return this.attachmentRemoved(this.applicant.documents.SPECIAL_WELFARE_CONTACT, attachment);
        },
        applicantDocumentSOCIAL_SUPPORT_ACTRemove(attachment){
            return this.attachmentRemoved(this.applicant.documents.SOCIAL_SUPPORT_ACT, attachment);
        },
        applicantDocumentMEDICAL_CONSENTRemove(attachment){
            return this.attachmentRemoved(this.applicant.documents.MEDICAL_CONSENT, attachment);
        },
        applicantDocumentEDUCATION_CONTRACTRemove(attachment){
            return this.attachmentRemoved(this.applicant.documents.EDUCATION_CONTRACT, attachment);
        },
        applicantDocumentQUOTATIONRemove(attachment){
            return this.attachmentRemoved(this.applicant.documents.QUOTATION, attachment);
        },
        applicantDocumentHEALTH_INSURANCE_POLICYRemove(attachment){
            return this.attachmentRemoved(this.applicant.documents.HEALTH_INSURANCE_POLICY, attachment);
        },
        applicantDocumentSPECIAL_WELFARE_CONTACTAdded(file){
          return this.applicantAttachmentAdded(
              this.applicant.documents.SPECIAL_WELFARE_CONTACT,
              Attachment.prototype.TYPE_SPECIAL_WELFARE_CONTACT,
              file,
              'SPECIAL_WELFARE_CONTACT'
          )
        },
        applicantDocumentSOCIAL_SUPPORT_ACTAdded(file){
          return this.applicantAttachmentAdded(
              this.applicant.documents.SOCIAL_SUPPORT_ACT,
              Attachment.prototype.TYPE_SOCIAL_SUPPORT_ACT,
              file,
              'SOCIAL_SUPPORT_ACT'
          )
        },
        applicantDocumentMEDICAL_CONSENTAdded(file){
          return this.applicantAttachmentAdded(
              this.applicant.documents.MEDICAL_CONSENT,
              Attachment.prototype.TYPE_MEDICAL_CONSENT,
              file,
              'MEDICAL_CONSENT'
          )
        },
        applicantDocumentEDUCATION_CONTRACTAdded(file){
          return this.applicantAttachmentAdded(
              this.applicant.documents.EDUCATION_CONTRACT,
              Attachment.prototype.TYPE_EDUCATION_CONTRACT,
              file,
              'EDUCATION_CONTRACT'
          )
        },
        applicantDocumentQUOTATIONAdded(file){
            return this.applicantAttachmentAdded(
                this.applicant.documents.QUOTATION,
                Attachment.prototype.TYPE_QUOTATION,
                file,
                'QUOTATION'
            )
        },
        applicantDocumentHEALTH_INSURANCE_POLICYAdded(file){
            return this.applicantAttachmentAdded(
                this.applicant.documents.HEALTH_INSURANCE_POLICY,
                Attachment.prototype.TYPE_HEALTH_INSURANCE_POLICY,
                file,
                'HEALTH_INSURANCE_POLICY'
            )
        },
        back: function () {
            const that = this;
            this.backBtnClicked = true;
            this.submitting = true;
            this.errorMessages = [];

            this.step8Submit(this.$data).finally(function () {
                that.$router.push({name: 'step7_expense'});
                that.backBtnClicked = false;
                that.submitting = false;
            });
        },
        submit: function () {
            const that = this;
            this.submitBtnClicked = true;
            this.submitting = true;
            this.errorMessages = [];

            this.step8Submit(this.$data)
                .then(function () {
                    that.$router.push({name: 'step9_signature'});
                })
                .catch(function (error) {
                    const response = error.response;
                    if (response.data !== undefined && response.data.error !== undefined) {
                        that.errorDetails = response.data.error.messages;
                        if (typeof response.data.error.messages === 'string') {
                            that.errorMessages = [response.data.error.messages];
                        } else {
                            that.errorMessages = ['Er ontbreken gegevens in deze stap'];
                        }
                    } else {
                        that.errorMessages = ['Onbekende fout!'];
                    }
                    that.$vuetify.goTo(that.$refs.errorMessages, {
                        duration: 300,
                        offset: 100,
                        easing: 'easeInOutCubic',
                    });
                })
                .finally(function () {
                    that.submitBtnClicked = false;
                    that.submitting = false;
                });
        },
    },
};
</script>
